import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { DashboardService } from '../../../services/dashboard.service';

import { Constants } from '../../../../../app.const';
import { WorkConstants } from "../../../../work/work.const";

declare var $: any;

@Component({
  selector: 'app-crowd-general',
  templateUrl: './crowd-general.component.html',
  styleUrls: ['./crowd-general.component.css'],
  providers: [DashboardService]
})
export class CrowdGeneralComponent implements OnInit {

  folderId: string;
  authUser: any = {};
  folderFileType: string;
  crowdGeneralList: Array<any> = [];
  private constants = Constants;

  constructor(
    private DashboardService: DashboardService,
  ) { }

  ngOnInit() {
    let $this = this;
    // get cv folder ID
    this.folderId = this.constants.driverCrowderiaGeneralFolderId;
    //get folder file type in google
    this.folderFileType = this.constants.folderMinTypeInGoogle;
    this.getGoogleFileList(this.folderId);

  }

  /**
   * kaushalya
   * 2017-07-21
   * get google drive folder content
   */
  getGoogleFileList(folderId) {
    this.DashboardService.getAvailableCvs({ folderId }).subscribe(
      res => {
        this.crowdGeneralList = Object.keys(res.data.fileList).map((key) => { return res.data.fileList[key] });
      }
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/crowd-general/crowd-general.component.ts